<!--动态图对象 右键属性-->
<template>
  <div>
    <gs-modal v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm" title="数据接口" :has-form="true"
      class="my-test-class" @close="close" @confirm="handleConfirm">
      <el-tree :data="dataTemp" @node-click="handleNodeClick" show-checkbox @check-change="handleCheckChange"></el-tree>
      <div class="bottom-btn">
        <gs-button @click="timeSyn">时间同步</gs-button>
        <gs-button @click="add">修改</gs-button>
        <gs-button @click="deleteTamp">删除</gs-button>
      </div>
    </gs-modal>
    <gs-modal v-model="dialogVisible" :before-close="beforeCloseAddTopic" title="添加TOPIC" @close="close"
      @confirm="handleConfirmAddTopic">
      <el-input v-model="inputTopic" placeholder="请输入TOPIC"></el-input>
      <el-upload class="upload-demo" ref="upload" action="doUpload" :limit="1" :file-list="fileList"
        :before-upload="beforeUpload">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <!--<a href="./static/moban.xlsx" rel="external nofollow" download="模板"><el-button size="small" type="success">下载模板</el-button></a>-->
        <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button> -->
        <div slot="tip" class="el-upload__tip">只能上传excel文件，且不超过5MB</div>
        <div slot="tip" class="el-upload-list__item-name">{{ fileName }}</div>
      </el-upload>
    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
export default {
  components: {

  },
  data() {
    return {
      fileName: '',
      fileList: [],
      inputTopic: '',
      dialogVisible: false,
      visibleAdd: false,
      visibleProperties: false,
      multipleSelection: [],
      dataTemp: [{
        label: '一级 1',
        children: [{
          label: '二级 1-1',
          children: [{
            label: '三级 1-1-1'
          }]
        }]
      }, {
        label: '一级 2',
        children: [{
          label: '二级 2-1',
          children: [{
            label: '三级 2-1-1'
          }]
        }, {
          label: '二级 2-2',
          children: [{
            label: '三级 2-2-1'
          }]
        }]
      }, {
        label: '一级 3',
        children: [{
          label: '二级 3-1',
          children: [{
            label: '三级 3-1-1'
          }]
        }, {
          label: '二级 3-2',
          children: [{
            label: '三级 3-2-1'
          }]
        }]
      }],
      idTree: ''
    }
  },
  computed: {
    ...mapState({
      visible: 'topicShow',
      nodeData: 'objectInfo'
    })
  },
  watch: {
  },
  created() {
    if (localStorage.getItem("Authorization")) {
      service.findTemplate().then(res => {
        this.dataTemp = res
      })
    }
  },
  mounted() {
    if (localStorage.getItem("Authorization")) {
      /* service.findAllTopic().then(res => {
        this.tableData = res
      }) */
    }
  },
  methods: {
    ...mapMutations({
      close: 'TOPIC_HIDE',
      needReload: 'TOPIC_TREE'
    }),
    handleCheckChange(data, checked, indeterminate) {
      this.idTree = data.id
    },
    handleNodeClick(treeData) {

    },
    deleteTamp() {
      service.deleteTemplate(this.idTree).then(res => {
        this.$Message.success("删除成功")
      }).catch(err => {
        this.$Message.error("删除失败")
        console.log(err)
      })
    },
    beforeClose() {
      this.close()
    },
    beforeCloseAddTopic() {
      this.dialogVisible = false
    },
    handleConfirmAddTopic() {
      let arr = []
      let topic = this.inputTopic
      arr.push(topic)
      service.addTopic(arr).then(resd => {
        service.findAllTopic().then(res => {
          this.$Message.success("添加成功")
          this.tableData = res
          this.inputTopic = ''
        }).catch(err => {
          this.inputTopic = ''
          this.$Message.error("查询失败")
          console.log(err)
        })
      }).catch(err => {
        this.inputTopic = ''
        this.$Message.error("添加失败")
        console.log(err)
      })

      this.dialogVisible = false
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      if (!this.form.primaryY_autoScale) {
        if (this.form.primaryY_Mininum >= this.form.primaryY_maximum) {
          this.$Message.warning('Y轴最小值必须小于最大值')
          return
        }
      }
      if (!this.form.secondaryY_autoScale) {
        if (this.form.secondaryY_Mininum >= this.form.secondaryY_maximum) {
          this.$Message.warning('Y轴最小值必须小于最大值')
          return
        }
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      let _this = this
      this.loading = true
      let arr = []
      let backArr = JSON.parse(JSON.stringify(this.form.objectSeries))
      this.form.objectSeries.forEach(e => {
        arr.push(e.id)
      })
      this.form.objectSeries = arr
      if (this.objectInfo.id && this.objectInfo.type === 'onlineChart') {
        let param = {
          id: this.objectInfo.id,
          'name': this.name,
          'type': this.objectInfo.type,
          value: this.objectInfo.value,
          'parentId': this.objectInfo.parentId,
          'description': this.description,
          'attribute': this.form // 其他信息这里，键值对形式
        }
        service.renamePoint(param).then(res => {
          this.loading = false
          this.$Message.success('修改成功')
          _this.objectInfo.attribute.objectSeries = backArr
          this.close()
          this.objectInfo.name = this.name
          res.attribute.objectSeries = backArr
          this.$store.state.tabPanel = res
          this.$store.state.updateTreeNode = res
          this.description = ''
          this.name = ''
          // this.form = {
          //   objectSeries: []
          // }
          this.showList = []
          // eventBus.$emit('changeInterval', res)
        }).catch(err => {
          this.loading = false
          this.form.objectSeries = backArr
          this.$Message.error(err.message)
        })
      } else {
        let param = {
          'name': this.name,
          'type': 'notebook',
          'parentId': this.objectInfo.id,
          'description': this.description,
          'attribute': this.form // 其他信息这里，键值对形式
        }
        service.newAddPoint(param).then(res => {
          this.loading = false
          this.$Message.success('添加成功')
          setTimeout(() => {
            res.attribute.objectSeries = backArr
            _this.$store.state.addTreeNode = res
          }, 0)
          this.close()
          this.description = ''
          this.name = ''
          // this.form = {
          //   objectSeries: []
          // }
          this.showList = []
        }).catch(err => {
          this.loading = false
          this.form.objectSeries = backArr
          this.$Message.error(err.message)
        })
      }
    },
    handleClick(row) {
      let arr = []
      let topic = row.topic
      arr.push(topic)
      service.rmTopic(arr).then(resd => {
        service.findAllTopic().then(res => {
          this.tableData = res
          this.$Message.success("删除成功")
        }).catch(err => {
          this.$Message.error("删除更新失败!!!请手动刷新")
          console.log(err)
        })
      }).catch(err => {
        this.$Message.error("删除失败")
        console.log(err)
      })
    },
    add() {
      this.dialogVisible = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    renovateTopic() {
      service.findAllTopic().then(res => {
        this.tableData = res
        this.$Message.success("刷新成功")
      }).catch(err => {
        console.log(err)
      })
    },
    // 时间同步
    timeSyn() {
      service.setTime().then(res => {
        this.$Message.success("同步成功")
      }).catch(err => {
        this.$Message.error("同步失败")
      })
    },
    // 上传检测
    beforeUpload(file) {
      console.log(file, '文件');
      this.files = file;
      const extension = file.name.split('.')[1] === 'xls'
      const extension2 = file.name.split('.')[1] === 'xlsx'
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!extension && !extension2) {
        this.$message.warning('上传模板只能是 xls、xlsx格式!')
        return
      }
      if (!isLt2M) {
        this.$message.warning('上传模板大小不能超过 5MB!')
        return
      }
      this.fileName = file.name;
      return false // 返回false不会自动上传
    },
  }
}
</script>
<style scoped>
.my-test-class>>>.el-table .cell {
  padding-left: 9px;
  padding-right: 0px;
}

.bottom-btn {
  margin: 20px;
  text-align: center
}
</style>



// WEBPACK FOOTER //
// src/components/notebook/topic.vue